import React from "react";
import { MInput, MSelect, ValidatedForm } from "components/forms";
import { dateHelper, payloadBuilder } from "libs";

export class FormTitleL2 extends ValidatedForm {
  emptyFields = {
    titleType: "",
    description: "",
    istitution: "",
    aa: "",
    dataConseguimento: "",
    votoTitolo: "",
  };

  istitutions_L2 = [
    { label: "Selezionare", value: "", titles: [] },
    {
      label: 'Università "Ca\' Foscari" di Venezia',
      value: "36",
      titles: [
        {
          label: "Master ITALS Didattica e promozione della lingua e della cultura italiana a stranieri",
          value: "Master ITALS Didattica e promozione della lingua e della cultura italiana a stranieri",
          type: "MASTER-I",
        },
        {
          label: "Master in Progettazione avanzata dell'insegnamento della lingua e cultura italiane a stranieri",
          value: "Master in Progettazione avanzata dell'insegnamento della lingua e cultura italiane a stranieri",
          type: "MASTER-II",
        },
        {
          label: "CEDILS: certificazione della competenza in didattica dell'italiano lingua straniera o lingua seconda",
          value: "CEDILS: certificazione della competenza in didattica dell'italiano lingua straniera o lingua seconda",
          type: "CERT",
        },
      ],
    },
    {
      label: "Università Cattolica del Sacro Cuore di Milano",
      value: "57",
      titles: [
        {
          label: "Master in Didattica dell'Italiano L2",
          value: "Master in Didattica dell'Italiano L2",
          type: "MASTER-I",
        },
      ],
    },
    {
      label: 'Università degli Studi "Carlo Bo" di Urbino',
      value: "63",
      titles: [
        {
          label:
            "Master Insegnare italiano a stranieri: scuola, università, impresa - limitatamente al Percorso A dedicato alla didattica dell'italiano L2",
          value:
            "Master Insegnare italiano a stranieri: scuola, università, impresa - limitatamente al Percorso A dedicato alla didattica dell'italiano L2",
          type: "MASTER-I",
        },
      ],
    },
    {
      label: 'Università degli Studi "G. D\'Annunzio" di Chieti-Pescara',
      value: "53",
      titles: [
        {
          label: "Master in Didattica dell'italiano lingua seconda e lingua straniera intercultura e mediazione",
          value: "Master in Didattica dell'italiano lingua seconda e lingua straniera intercultura e mediazione",
          type: "MASTER-I",
        },
      ],
    },
    {
      label: 'Università degli Studi "L\'Orientale" di Napoli',
      value: "42",
      titles: [
        {
          label: "Master in Didattica dell'Italiano L2",
          value: "Master in Didattica dell'Italiano L2",
          type: "MASTER-II",
        },
      ],
    },
    {
      label: 'Università degli Studi "Tor Vergata" di Roma',
      value: "27",
      titles: [
        {
          label: "Master Insegnare Lingua e Cultura Italiana a Stranieri (LCS)",
          value: "Master Insegnare Lingua e Cultura Italiana a Stranieri (LCS)",
          type: "MASTER-II",
        },
      ],
    },
    {
      label: "Università degli Studi dell'Insubria",
      value: "C7",
      titles: [
        {
          label: "Master in Formatori Interculturali di Lingua Italiana per Stranieri - FILIS",
          value: "Master in Formatori Interculturali di Lingua Italiana per Stranieri - FILIS",
          type: "MASTER-I",
        },
      ],
    },
    {
      label: "Università degli Studi di Macerata",
      value: "13",
      titles: [
        {
          label: "Master in Didattica dell'italiano L2/LS in prospettiva interculturale",
          value: "Master in Didattica dell'italiano L2/LS in prospettiva interculturale",
          type: "MASTER-I",
        },
      ],
    },
    {
      label: "Università degli Studi di Milano",
      value: "15",
      titles: [
        {
          label: "Master PROMOITALS Promozione e insegnamento della lingua e cultura italiana a stranieri",
          value: "Master PROMOITALS Promozione e insegnamento della lingua e cultura italiana a stranieri",
          type: "MASTER-I",
        },
      ],
    },
    {
      label: "Università degli Studi di Padova",
      value: "19",
      titles: [
        {
          label: "Master in Didattica dell'italiano come L2",
          value: "Master in Didattica dell'italiano come L2",
          type: "MASTER-I",
        },
      ],
    },
    {
      label: "Università degli Studi di Palermo",
      value: "20",
      titles: [
        {
          label: "Master di I livello in didattica dell'italiano come Lingua non materna",
          value: "Master di I livello in didattica dell'italiano come Lingua non materna",
          type: "MASTER-I",
        },
        {
          label: "Master in Teoria, progettazione e didattica dell'italiano come lingua seconda e straniera",
          value: "Master in Teoria, progettazione e didattica dell'italiano come lingua seconda e straniera",
          type: "MASTER-II",
        },
      ],
    },
    {
      label: "Università degli Studi di Torino",
      value: "31",
      titles: [
        {
          label: "Master in Didattica dell'italiano L2 (MITAL2)",
          value: "Master in Didattica dell'italiano L2 (MITAL2)",
          type: "MASTER-I",
        },
      ],
    },
    {
      label: "Università degli Studi di Udine",
      value: "34",
      titles: [
        {
          label: "Master Italiano lingua seconda e interculturalità",
          value: "Master Italiano lingua seconda e interculturalità",
          type: "MASTER-I",
        },
      ],
    },
    {
      label: "Università degli Studi di Verona",
      value: "40",
      titles: [
        {
          label: 'Master di I livello in "Didattica dell\'Italiano come lingua seconda L2"',
          value: 'Master di I livello in "Didattica dell\'Italiano come lingua seconda L2"',
          type: "MASTER-I",
        },
      ],
    },
    {
      label: "Università della Calabria",
      value: "05",
      titles: [
        {
          label: "Master in Didattica dell'italiano come L2",
          value: "Master in Didattica dell'italiano come L2",
          type: "MASTER-II",
        },
      ],
    },
    {
      label: "Università Telematica e-Campus",
      value: "D9",
      titles: [
        {
          label: "Master di I livello in \"L'insegnamento dell'Italiano agli stranieri, L2\"",
          value: "Master di I livello in \"L'insegnamento dell'Italiano agli stranieri, L2\"",
          type: "MASTER-I",
        },
      ],
    },
    {
      label: "Università per stranieri di Perugia",
      value: "99",
      titles: [
        {
          label: "Master in didattica dell'italiano lingua non materna",
          value: "Master in didattica dell'italiano lingua non materna",
          type: "MASTER-I",
        },
        {
          label: 'Master di II livello in "Didattica dell\'italiano lingua non materna"',
          value: 'Master di II livello in "Didattica dell\'italiano lingua non materna"',
          type: "MASTER-II",
        },
        {
          label: "DILS-PG (II livello)",
          value: "DILS-PG (II livello)",
          type: "CERT",
        },
      ],
    },
    {
      label: "Università per Stranieri di Perugia e Università per Stranieri di Siena (erogato dal Consorzio ICoN)",
      value: "ICoN",
      titles: [
        {
          label: "Master in Didattica della Lingua e della Letteratura Italiana",
          value: "Master in Didattica della Lingua e della Letteratura Italiana",
          type: "MASTER-I",
        },
      ],
    },
    {
      label: "Università per stranieri di Siena",
      value: "97",
      titles: [
        {
          label: "Scuola di Specializzazione in Didattica dell'Italiano a Stranieri",
          value: "Scuola di Specializzazione in Didattica dell'Italiano a Stranieri",
          type: "SPECIALIZZAZIONE",
        },
        {
          label: "Master DITALS",
          value: "Master DITALS",
          type: "MASTER-I",
        },
        {
          label: "Contenuti, metodi ed approcci per insegnare la lingua italiana ad adulti stranieri",
          value: "Contenuti, metodi ed approcci per insegnare la lingua italiana ad adulti stranieri",
          type: "MASTER-I",
        },
        {
          label: "Master Inter - Imm Intercomprensione e Immigrazione: italiano per le professioni e per il carcere",
          value: "Master Inter - Imm Intercomprensione e Immigrazione: italiano per le professioni e per il carcere",
          type: "MASTER-II",
        },
        {
          label: "Master ELIIAS E-learning per l'insegnamento dell'italiano a stranieri",
          value: "Master ELIIAS E-learning per l'insegnamento dell'italiano a stranieri",
          type: "MASTER-II",
        },
        {
          label: "DITALS di II livello",
          value: "DITALS di II livello",
          type: "CERT",
        },
      ],
    },
  ];

  ERROR_MESSAGES = {
    titleType: "Dato obbligatorio",
    istitution: "Dato obbligatorio",
    description: "Dato obbligatorio",
    dataConseguimento: "Dato obbligatorio",
    aa: "Inserire l'anno accademico in formato AAAA/AAAA",
    votoTitolo: "Dato obbligatorio",
  };

  validation = {
    titleType: (value) => value !== "",
    istitution: (value) => value !== "",
    description: (value) => value !== "",
    dataConseguimento: (value) => this.validateDataConseguimento(value),
    aa: (value) => this.validateAA(value),
    votoTitolo: (value) => value !== "",
  };

  constructor(props) {
    super(props);

    this.onChangeEvents = {
      titleType: this.onTitleTypeChange,
      istitution: this.onIstitutionChange,
    };
  }

  onTitleTypeChange = (id, value) => {
    this.setState((prevState) => ({
      istitution: "",
      description: "",
      defaultValues: {
        ...prevState.defaultValues,
        istitution: "",
        description: "",
      },
      refreshKey: (prevState.refreshKey || 0) + 1,
    }));

    let istitutionOptions = [{ label: "Selezionare", value: "" }];

    if (value) {
      const filteredIstitutions = this.istitutions_L2.filter((istitution) => istitution.titles.some((title) => title.type === value));

      istitutionOptions = [...istitutionOptions, ...filteredIstitutions.map((istitution) => ({ label: istitution.label, value: istitution.value }))];
    }

    this.updatePayload("istitutionL2", istitutionOptions);
    this.updatePayload("descriptionL2", [{ label: "Selezionare", value: "" }]);
  };

  onIstitutionChange = (id, value) => {
    this.setState((prevState) => ({
      description: "",
      defaultValues: {
        ...prevState.defaultValues,
        description: "",
      },
      refreshKey: (prevState.refreshKey || 0) + 1,
    }));

    let titleOptions = [{ label: "Selezionare", value: "" }];
    let filteredTitles = [];

    const currentTitleType = this.state.titleType?.value || this.state.titleType || "";

    if (value && currentTitleType) {
      const selectedIstitution = this.istitutions_L2.find((istitution) => istitution.value === value);

      if (selectedIstitution) {
        filteredTitles = selectedIstitution.titles.filter((title) => title.type === currentTitleType);
        titleOptions = [...titleOptions, ...filteredTitles.map((title) => ({ label: title.label, value: title.value }))];
      }
    }

    this.updatePayload("descriptionL2", titleOptions);
  };

  validateAA = (value) => {
    let aa = /^(\d{4})\/(\d{4})$/.test(value);

    if (!aa) {
      return false;
    } else {
      aa = value.split("/");
      if (parseInt(aa[1]) === parseInt(aa[0]) + 1) {
        return true;
      } else {
        return false;
      }
    }
  }; //validateAA

  validateDataConseguimento = (value) => {
    if (value === "") {
      return false;
    }
    let regex = /^\d{4}-\d{2}-\d{2}$/;

    if (!value.match(regex)) {
      return false;
    }
    const date = new Date(value);

    if (Number.isNaN(date.getTime())) {
      return false;
    }
    const [year, month, day] = value.split("-").map(Number);

    if (month > 12) {
      return false;
    }
    if (day > 31) {
      return false;
    }

    const noFuture = dateHelper.noFuture(value);
    if (noFuture === false) {
      return false;
    }

    const currentYear = new Date().getFullYear();
    if (year < currentYear - 70 || year > currentYear) {
      return false;
    }

    return true;
  };

  state = {
    ...this.emptyFields,
    defaultValues: { ...this.emptyFields },
    refreshKey: 0,
  };

  FIELDS_GROUP = [
    [
      {
        id: "titleType",
        field: "titleType",
        label: "Tipologia titolo",
        component: MSelect,
        payload: {
          options: [
            { label: "Selezionare", value: "" },
            { label: "Diploma di specializzazione biennale", value: "SPECIALIZZAZIONE" },
            { label: "Master di I livello", value: "MASTER-I" },
            { label: "Master di II livello", value: "MASTER-II" },
            { label: "Certificazione di glottodidattica di II livello", value: "CERT" },
          ],
        },
        className: "col-md-6",
      },
      {
        id: "istitutionL2",
        field: "istitution",
        label: "Presso",
        component: MSelect,
        payload: { options: [{ label: "Selezionare", value: "" }] },
        className: "col-md-6",
      },
    ],
    [
      {
        id: "descriptionL2",
        field: "description",
        label: "Denominazione",
        component: MSelect,
        payload: { options: [{ label: "Selezionare", value: "" }] },
        className: "col-md-12",
      },
    ],
    [
      {
        id: "aaL2",
        field: "aa",
        label: "Anno Accademico conseguimento Titolo",
        component: MInput,
        infoText: "inserire formato AAAA/AAAA",
        className: "col-md-4",
      },
      {
        id: "dataConseguimentoL2",
        field: "dataConseguimento",
        label: "Data conseguimento titolo",
        component: MInput,
        type: "date",
        className: "col-md-4",
      },
      {
        id: "votoTitoloL2",
        field: "votoTitolo",
        label: "Votazione",
        component: MInput,
        type: "text",
        className: "col-md-4",
      },
    ],
  ];

  processDefaultPayload = (payload) => {
    const typeOption = this.FIELDS_GROUP[0][0].payload.options.find((opt) => opt.label === payload.qualificationType);

    if (typeOption) {
      payload.titleType = typeOption.value;
    }

    payload.istitution = payload.uniCode;

    return payload;
  };

  initializeDropdowns = (titleType, istitution) => {
    let istitutionOptions = [{ label: "Selezionare", value: "" }];
    let titleOptions = [{ label: "Selezionare", value: "" }];

    const filteredIstitutions = this.istitutions_L2.filter((istitution) => istitution.titles.some((title) => title.type === titleType));
    istitutionOptions = [...istitutionOptions, ...filteredIstitutions.map((istitution) => ({ label: istitution.label, value: istitution.value }))];

    const selectedIstitution = this.istitutions_L2.find((i) => i.value === istitution);
    const filteredTitles = selectedIstitution.titles.filter((title) => title.type === titleType);
    titleOptions = [...titleOptions, ...filteredTitles.map((title) => ({ label: title.label, value: title.value }))];

    this.updatePayload("istitutionL2", istitutionOptions);
    this.updatePayload("descriptionL2", titleOptions);
  };

  componentDidMount() {
    const { defaultPayload } = this.props;

    if (defaultPayload) {
      const processedPayload = this.processDefaultPayload(defaultPayload);
      this.initializeDropdowns(processedPayload.titleType, processedPayload.istitution);

      this.setState({
        defaultValues: { ...this.emptyFields, ...processedPayload },
        ...processedPayload,
      });
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.defaultPayload && this.props.defaultPayload !== prevProps.defaultPayload) {
      const processedPayload = this.processDefaultPayload(this.props.defaultPayload);
      this.initializeDropdowns(processedPayload.titleType, processedPayload.istitution);

      this.setState({
        defaultValues: { ...this.emptyFields, ...processedPayload },
        ...processedPayload,
      });
    }
  }

  updatePayload = (fieldId, options) => {
    this.FIELDS_GROUP.forEach((row) => {
      row.forEach((field) => {
        if (field.id === fieldId) {
          if (!field.payload) field.payload = {};
          field.payload.options = options;
        }
      });
    });
  };

  getPayload = () => {
    this.payload = payloadBuilder(this.state);

    const titleType = this.FIELDS_GROUP[0][0].payload.options.find((option) => option.value === this.payload.titleType);
    const istitution = this.FIELDS_GROUP[0][1].payload.options.find((option) => option.value === this.payload.istitution);

    this.payload.qualificationType = titleType.label;
    this.payload.qualificationCode = this.props.qualificationCode;
    this.payload.template = this.props.template;
    this.payload.uniCode = this.state.istitution.value || this.state.istitution;
    this.payload.istitution = istitution.label;

    if (!this.payload.nation) {
      this.payload.nation = "Italia";
    }

    return this.payload;
  };

  //--- ---
  render() {
    const { defaultValues, refreshKey } = this.state;
    const { code } = this.renderFields(this.FIELDS_GROUP, defaultValues, true);

    return (
      <>
        <form key={`form_${refreshKey}`} className="user mt-5">
          {code}
        </form>
      </>
    );
  }
}
